/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type CaptureCommandInCommand = typeof CaptureCommandInCommand[keyof typeof CaptureCommandInCommand];


export const CaptureCommandInCommand = {
  stop: 'stop',
  leave: 'leave',
  pause: 'pause',
  resume: 'resume',
} as const;
